<template>
  <div id="boleta">
        <div v-for="(alumno, a) in alumnos" :key="a" :style="{ display: descargaVisible ? 'block' : 'none' }">
            <div class="alumnoDescargarBoleta" style="width: 1240px; height: 1754px; color: black;">
                <div class="content">
                    <div class="objetfit mb-1" style="height: 150px; margin-bottom: 5px; display:flex; align-items: center; justify-content: center;">
                        <img style="width: 100%;" :src="'/img/cabeceras/' + institucion + '.png'" alt="cabecera" @error="setImagenFooter">
                    </div>
                    <div style="border: 1px solid #D9D9D9; padding: 5px 9px; margin-bottom: 5px;">
                        <vs-row>
                            <vs-col w="5">
                                <p class="fontSix lineTogether"><strong>ALUMNO: </strong> <span class="text-uppercase">{{alumno.nombre}}</span></p>
                            </vs-col>
                            <vs-col w="3">
                                <p class="fontSix lineTogether" style="padding: 0 9px;"><strong>MATRÍCULA: </strong> <span class="text-uppercase">{{alumno.matricula}}</span></p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontSix lineTogether" style="padding-right: 18px;"><strong>EMAIL: </strong> <span class="text-uppercase">{{alumno.correo_institucional}}</span></p>
                            </vs-col>
                            <vs-col w="5">
                                <p class="fontSix lineTogether"><strong>SALÓN: </strong> <span class="text-uppercase">{{alumno.grupo_administrativo}}</span></p>
                            </vs-col>
                            <vs-col w="3">
                                <p class="fontSix lineTogether" style="padding: 0 9px;"><strong>NO. LISTA: </strong> <span class="text-uppercase">{{alumno.no_lista}}</span></p>
                            </vs-col>
                            <vs-col w="4">
                                <p class="fontSix lineTogether" style="padding-right: 18px;"><strong>CICLO: </strong> <span>{{filtros.cicloEscolarName.text}}</span></p>
                            </vs-col>
                            <vs-col w="5">
                                <p class="fontSix lineTogether"><strong>PROGRAMA: </strong> <span class="text-uppercase">{{filtros.programaName.text}}</span></p>
                            </vs-col>
                            <vs-col w="3">
                                <p class="fontSix lineTogether" style="padding: 0 9px;"><strong>GRADO: </strong> <span class="text-uppercase">{{alumno.grado}}</span></p>
                            </vs-col>
                        </vs-row>
                    </div>
                    <div class="d-flex padding9">
                        <div style="width: 25%">
                        </div>
                        <div class="d-flex" style="width: 75%">
                            <template v-for="(cabecera, c) in alumno.header_periodos">
                                <div v-if="tipo_formato == 'admin' ? true : verInfo[c] && verInfo[c].status == true" class="fontSix px-1 cabeceraTable" :class="'widthCabecera' + numCabecera" :key="c">
                                    <p style="hyphens: auto;">{{cabecera.periodo}} </p>
                                </div>
                            </template>
                        </div>
                    </div>
                    <template v-if="[1,2,3].includes(nivel)">
                        <template v-if="alumno && alumno.materias_promediables && alumno.materias_promediables.campos_formativos && alumno.materias_promediables.campos_formativos.materias_sin_campo_formativo && alumno.materias_promediables.campos_formativos.materias_sin_campo_formativo[0]">
                            <div class="backgroundCampos mt-1" v-for="(mat, m) in alumno.materias_promediables.campos_formativos.materias_sin_campo_formativo" :key="m + 'a'">
                                <div class="d-flex align-items-center">
                                    <div style="width: 25%; padding-left: 3px;">
                                        <p class="fontEight lineTogether"><span class="font-weight-bold">{{mat.materia}}</span> ({{mat.clave}})</p>
                                        <p class="fontSix lineTogether" style="text-transform: capitalize;">Docente: <span class="font-weight-bold text-capitalize">{{mat.docente}}</span></p>
                                        <p v-if="mat.no_asistencia" class="fontSix lineTogether" style="text-transform: capitalize;">No. de asistencia: <span class="font-weight-bold text-capitalize">{{mat.no_asistencia}}/{{mat.no_asistencia_total}}</span></p>
                                    </div>
                                    <div class="d-flex" style="width: 75%" >
                                        <template v-for="(cal, ca) in mat.periodos">
                                            <div v-if="tipo_formato == 'admin' ? true : cal.detalle_componente_id == (verInfo[ca] && verInfo[ca].detalle)" :key="ca" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                                <p :class="cal.detalle_componente_tipo == 'calculado' ? 'fs-18 fw-bold' : ''" v-if="cal.calificacion !== '' && cal.calificacion !== null">{{cal.calificacion == 0 ? '-' : cal.calificacion}}</p>
                                                <p v-else>-</p>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div :class="alumno.materias_promediables.materias != (m + 1) ? 'lineSeparador' : ''"></div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="backgroundCampos padding9" v-for="(campo_formativo, cf) in alumno.materias_promediables.campos_formativos.materias_con_campo_formativo" :key="cf">
                                <div class="d-flex align-items-center">
                                    <div style="width: 25%">
                                        <p class="text-uppercase font-weight-bold fontNine" style="line-height: 1;">{{cf}}</p>
                                    </div>
                                    <div class="d-flex" style="width: 75%" >
                                        <template v-if="[2].includes(nivel)">
                                            <template v-for="(per, p) in alumno.header_periodos">
                                                <div v-if="tipo_formato == 'admin' ? true : per.detalle_componente_id == (verInfo[p] && verInfo[p].detalle)"  class="fontSix px-1 cabeceraTable" :key="p" :class="'widthCabecera' + numCabecera">
                                                    <p class="text-uppercase font-weight-bold fontNine" style="line-height: 1;">{{getCalificacionById(alumno.materias_promediables.campos_formativos.materias_con_campo_formativo[cf].periodos, per)}}</p>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div v-for="(mat, m) in alumno.materias_promediables.campos_formativos.materias_con_campo_formativo[cf].materias" :key="m">
                                    <div class="d-flex align-items-center">
                                        <div style="width: 25%; padding-left: 3px;">
                                            <p class="fontEight lineTogether"><span class="font-weight-bold">{{mat.materia}}</span> ({{mat.clave}})</p>
                                            <p class="fontSix lineTogether" style="text-transform: capitalize;">Docente: <span class="font-weight-bold text-capitalize">{{mat.docente}}</span></p>
                                            <p v-if="mat.no_asistencia" class="fontSix lineTogether" style="text-transform: capitalize;">No. de asistencia: <span class="font-weight-bold text-capitalize">{{mat.no_asistencia}}/{{mat.no_asistencia_total}}</span></p>
                                        </div>
                                        <div class="d-flex" style="width: 75%" >
                                            <template v-for="(cal, ca) in mat.periodos">
                                                <div v-if="tipo_formato == 'admin' ? true : cal.detalle_componente_id == (verInfo[ca] && verInfo[ca].detalle)" :key="ca" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                                    <p :class="cal.detalle_componente_tipo == 'calculado' ? 'fs-18 fw-bold' : ''" v-if="cal.calificacion !== '' && cal.calificacion !== null">{{cal.calificacion == 0 ? '-' : cal.calificacion}}</p>
                                                    <p v-else>-</p>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div :class="alumno.materias_promediables.campos_formativos.materias_con_campo_formativo[cf].materias.length != (m + 1) ? 'lineSeparador' : ''"></div>
                                </div>
                                <div class="lineSeparadorCampoFormativo"></div>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <div class="backgroundCampos mt-1 padding9" style="padding: 0px 9px;" v-for="(mat, m) in alumno.materias_promediables.materias" :key="m + 'a'">
                            <div class="d-flex align-items-center">
                                <div style="width: 25%; padding-left: 3px;">
                                    <p class="fontEight lineTogether"><span class="font-weight-bold">{{mat.materia}}</span> ({{mat.clave}})</p>
                                    <p class="fontSix lineTogether" style="text-transform: capitalize;">Docente: <span class="font-weight-bold text-capitalize">{{mat.docente}}</span></p>
                                    <p v-if="mat.no_asistencia" class="fontSix lineTogether" style="text-transform: capitalize;">No. de asistencia: <span class="font-weight-bold text-capitalize">{{mat.no_asistencia}}/{{mat.no_asistencia_total}}</span></p>
                                </div>
                                <div class="d-flex" style="width: 75%" >
                                    <template v-for="(cal, ca) in mat.periodos">
                                        <div v-if="tipo_formato == 'admin' ? true : cal.detalle_componente_id == (verInfo[ca] && verInfo[ca].detalle)" :key="ca" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                            <p :class="cal.detalle_componente_tipo == 'calculado' ? 'fs-18 fw-bold' : ''" v-if="cal.calificacion !== '' && cal.calificacion !== null">{{cal.calificacion == 0 ? '-' : cal.calificacion}}</p>
                                            <p v-else>-</p>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div :class="alumno.materias_promediables.materias != (m + 1) ? 'lineSeparador' : ''"></div>
                        </div>
                    </template>
                    <div class="d-flex align-items-center padding9" style="background:#1B3966; padding: 6px 0; color: white;">
                        <div style="width: 25%">
                            <p class="text-right font-weight-bold fontNine" style="line-height: 1;"><i>Promedios</i></p>
                        </div>
                        <div class="d-flex" style="width: 75%" >
                            <template v-for="(per, p) in alumno.header_periodos">
                                <div v-if="tipo_formato == 'admin' ? true : per.detalle_componente_id == (verInfo[p] && verInfo[p].detalle)" class="fontSix px-1 cabeceraTable" :key="p" :class="'widthCabecera' + numCabecera">
                                    <p class="text-uppercase font-weight-bold fontNine" style="line-height: 1;">{{getPromediosById(alumno.materias_promediables.promedio_general, per)}}</p>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="backgroundCampos padding9" v-for="(mat, m) in alumno.materias_no_promediables" :key="m+1">
                        <div class="d-flex align-items-center">
                            <div style="width: 25%; padding-left: 3px;">
                                <p class="fontEight lineTogether"><span class="font-weight-bold">{{mat.materia}}</span><span v-if="mat.clave">({{mat.clave}})</span> </p>
                                <p v-if="mat.docente" class="fontSix lineTogether" style="text-transform: capitalize;">Docente: <span class="font-weight-bold text-capitalize">{{mat.docente}}</span></p>
                                <p v-if="mat.no_asistencia" class="fontSix lineTogether" style="text-transform: capitalize;">No. de asistencia: <span class="font-weight-bold text-capitalize">{{mat.no_asistencia}}/{{mat.no_asistencia_total}}</span></p>
                            </div>
                            <div class="d-flex" style="width: 75%" >
                                <template v-for="(cal, ca) in mat.periodos">
                                    <div v-if="tipo_formato == 'admin' ? true : cal.detalle_componente_id == (verInfo[ca] && verInfo[ca].detalle)" :key="ca" class="fontEight px-1 cabeceraTable" :class="'widthCabecera' + numCabecera">
                                        <p :class="cal.detalle_componente_tipo == 'calculado' ? 'fs-18 fw-bold' : ''" v-if="cal.calificacion !== '' && cal.calificacion !== null">{{cal.calificacion == 0 ? '-' : cal.calificacion}}</p>
                                        <p v-else>-</p>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="lineSeparadorCampoFormativo"></div>
                    </div>
                    <div class="pl-3">
                        <p>Fecha de descarga: {{hoy_hora}}</p>
                    </div>
                    <div class="bottom-div" style="height: 150px; margin-bottom: 5px; display:flex; align-items: center; :justify-content: center;">
                        <img :src="'/img/cabeceras/' + institucion + '__footer.png'" alt="footer" style="width: 100%;;" @error="setImagenFooter">
                    </div>
                </div>
            </div>
            <div v-if="nivel == 2 && observaciones.length" class="alumnoDescargarBoleta" style="width: 1240px; height: 1754px; color: black;">
                <div class="content padding9">
                    <div class="d-flex justify-content-between align-items-center">
                        <h4>ANEXO OBSERVACIONES</h4>
                        <p class="fontSix"><small>ALUMNO: </small><strong>{{observaciones[a].nombre_alumno}}</strong></p>
                        <p class="fontSix"><small>MATRÍCULA: </small><strong>{{observaciones[a].matricula}}</strong></p>
                    </div>
                    <div v-for="(periodo, p) in observaciones[a].periodos" :key="'p' + p">
                        <vs-row  class="align-items-center">
                            <vs-col w="1">
                                <div style="height: 100%; -webkit-transform: rotate(-90deg); -moz-transform: rotate(-90deg);">
                                    <p class="text-center fontNine">{{periodo.periodo}}</p>
                                </div>
                            </vs-col>
                            <vs-col w="11">
                                <div class="obsCampoFormativo" >
                                    <div>
                                        <div v-for="(camp, p) in periodo.campos_formativos" :key="'p' + p">
                                            <div :class="periodo.campos_formativos.length == (p + 1) ? '' : 'divisorObs'">
                                                <p class="text-center mb-0 fontTen lineTogether"><strong>{{camp.campo_formativo}}</strong></p>
                                                <template v-if="camp.observaciones_ids[0]">
                                                    <p v-for="(obs, o) in camp.observaciones_ids" :key="'o' + o" class="mb-0 fontTen lineTogether"><i class="fas fa-caret-right mr-1"></i>{{obs}}</p>
                                                </template>
                                                <p class="fontTen lineTogether" v-else>No hay observaciones</p>
                                            </div>
                                            <div :class="periodo.campos_formativos.length == (p + 1 ) ? '' : 'lineSeparadorCampoFormativo'"></div>
                                        </div>
                                    </div>
                                </div>
                            </vs-col>
                        </vs-row>
                        <div class="lineSeparadorCampoFormativo"></div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import reportes from '../../../../../api/requests/reportes.js'
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
export default {
    props: ['nivel','alumnos', 'observaciones', 'institucion', 'cabecera', 'filtros', 'nombreArchivo'],
    data:() => ({
        tipo: 1,
        numCabecera: '',
        tipo_formato: '',
        verInfo: [],
        mostrar: false,
        descargaVisible: false, // Nuevo estado
        loadingDescarga: null,
        hoy_hora: '',
        hoy: ''
    }),
    created(){
        const fechaAcutal = new Date()
        const fecha = fechaAcutal.getDate() + '-' + ( fechaAcutal.getMonth() + 1 ) + '-' + fechaAcutal.getFullYear()
        const hora = fechaAcutal.getHours() + ':' + fechaAcutal.getMinutes() + ':' + fechaAcutal.getSeconds()
        this.hoy_hora = fecha + ' ' + hora
        this.hoy = fecha
    },
  methods: {
    setImagenFooter(event){
        event.target.src = "/img/cabeceras/transparentFooter.png"
    },
    async generateAndDownloadPDF() {
      // Crea un nuevo objeto jsPDF
      const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'letter',
          compress: true,
          fontSize: 12,
          lineHeight: 1.2,
          setMargins: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        });

        // Nombre del archivo PDF
        const pdfFileName = this.hoy + '_' + this.nombreArchivo + '.pdf';
      // Itera sobre los elementos y agrega cada página al PDF
      
      const pages = document.querySelectorAll('.alumnoDescargarBoleta');
      for (let i = 0; i < pages.length; i++) {
        
        //Muestra el prograso en el loading
        this.loadingDescarga.close()
        this.loadingProgreso(Math.round(i / pages.length * 100))

        const pageContent = pages[i];

        // Genera y agrega la página al PDF
        await this.addPageToPDF(pdf, pageContent);

        // Agrega una nueva página al PDF (excepto en la última iteración)
        if (i < pages.length - 1) {
          pdf.addPage();
        }
      }
      // Guarda o abre el PDF
      pdf.save(pdfFileName)
      this.descargaVisible = false;
      this.loadingDescarga.close()
    },
    async addPageToPDF(pdf, pageContent) {
      // Usa html2canvas para capturar el contenido como una imagen
      const canvas = await html2canvas(pageContent, {
        scale: 1, // Ajusta la escala para mejorar la calidad
        quality: 0.3, // Ajusta la calidad de la imagen
        });

      // Convierte la imagen del canvas a datos URL
      const imageData = canvas.toDataURL("image/png");

      // Agrega la imagen al PDF
      pdf.addImage(imageData, "PNG", 3, 3, 210, 285, '', 'FAST', 'SLOW');
    },
    getNumTotalCabecera(){
        const cabecera = this.alumnos[0].header_periodos
        const rol = 'administrador'
        const vm = this
        if(rol == 'administrador'){
            vm.numCabecera = cabecera.length
        }
    },
    getCalificacionById(periodos, cabecera){
        //Colocar el promedio en el periodo correspondiente de campos formativos
        let calif = ''
        periodos.forEach(p => {
            if(p.detalle_componente_id == cabecera.detalle_componente_id){
                calif = p.calificacion
                return false
            }
        })
        return calif
    },
    getPromediosById(periodos, promedio){
        //Colocar el promedio en el periodo correspondiente
        let calif = ''
        periodos.forEach(p => {
            if(p.detalle_componente_id == promedio.detalle_componente_id){
                calif = p.calificacion
                return false
            }
        })
        return calif
    },
    getPeriodosShow(info){
        const arreglo = []
        const infor = this.alumnos[0].header_periodos
        infor.forEach(element => {
            let array = {}
            if(element.status_show_alumno == true){
                array = {
                    detalle: element.detalle_componente_id,
                    status: true
                }
            }else{
                array = {
                    nombre: false,
                    status: false
                }
            }
            arreglo.push(array)
        })
        this.verInfo = arreglo
    },
    loadingProgreso(num){
    this.loadingDescarga = this.$vs.loading({
        text: 'No cierre la ventana. Generando PDF: ' + num + '%'
      });
    },
    async getCalificaciones(tipo) {
        this.loadingProgreso(0)
      this.tipo_formato = tipo;
      try {
        this.descargaVisible = true;
        this.getNumTotalCabecera();
        this.getPeriodosShow();
        setTimeout(()=>{
            this.generateAndDownloadPDF()
        }, 500)
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style scoped>
.objetfit > img{
	width: 1240px;
	height: 150px;
	object-fit: cover;

}
.fontTen{
    font-size: 11px;
}
.fontSix{
    font-size: 12px;
}
.fontEight{
    font-size: 14px;
}
.fontNine{
    font-size: 15px;
}

.cabeceraTable{
    font-weight: 500;
    line-height: 1.5;
    text-align: center;
}

p{
    margin-bottom: 0;
}

.lineTogether {
    line-height: 1.5;
}

table tr th{
    font-size: 7px;
    margin: 0 2px;
}

.widthCabecera2{
    width: 50%;
}
.widthCabecera3{
    width: 33.3%;
}
.widthCabecera4{
    width: 25%;
}
.widthCabecera5{
    width: 20%;
}
.widthCabecera6{
    width: 16.6%;
}
.widthCabecera7{
    width: 14.28%;
}
.widthCabecera8{
    width: 12.5%;
}
.widthCabecera9{
    width: 11.11%;
}
.widthCabecera10{
    width: 10%;
}
.widthCabecera11{
    width: 9%;
}
.widthCabecera12{
    width: 8.33%;
}
.widthCabecera13{
    width: 7.69%;
}
.widthCabecera14{
    width: 7.14%;
}
.widthCabecera15{
    width: 6.66%;
}
.widthCabecera16{
    width: 6.25%;
}

.lineSeparadorCampoFormativo{
    width: 100%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0;
}
.lineSeparador{
    width: 99.5%;
    height: 1px;
    background: #D9D9D9;
    margin: 2px 0 2px 0.5%;
}
.backgroundCampos:nth-last-child(even){
    background: rgba(217, 217, 217, 0.6);
}
.bottom-div {
    position: absolute;
    bottom: 35px;
    width: 1240px;
    text-align: center;
}
.padding9{
    padding: 0 9px;
}
.fs-18{
    font-size: 17px;
}
.fw-bold{
    font-weight: bold;
}
</style>
